import { Flex } from '@chakra-ui/react';
import { CustomerUser } from '@texas/api/endpoints/customerUsersApi';
import { UserAvatar } from '@texas/components/shared/users/UserAvatar';
import { useActiveSession } from '@texas/hooks/useSession';
import { AddUser } from './AddUser';
import { UserType } from '@texas/api/endpoints/userApi';
import { compareEnum } from '@texas/utils/helpers/enumHelpers';
import { useTranslation } from 'react-i18next';
import { IconUtilButtons } from './IconUtilButtons';
import { getUserTypeLabel } from './shared';
import {
  TeamMatrixCell,
  TeamMatrixRoleHeader,
} from '@texas/components/shared/users/TeamMatrix';

export function UserRoleRow({
  title,
  rowIndex,
  users,
  userType,
  onAddClick,
  onChangeCustomTypeClick,
}: {
  rowIndex: number;
  users: CustomerUser[];
  userType: UserType | null;
  onAddClick: (branchId: number) => void;
  onChangeCustomTypeClick?: (id: number, type: string) => void;
  title: string;
}) {
  const session = useActiveSession();
  const { t } = useTranslation();

  return (
    <>
      <TeamMatrixRoleHeader rowIndex={rowIndex} title={title} />
      {session.branches.map((x, i) => {
        return (
          <TeamMatrixCell key={x.id} columnIndex={i + 2} rowIndex={rowIndex}>
            <Flex flexDir="column" gap={3}>
              {users
                .filter(
                  (x2) =>
                    compareEnum(UserType, x2.userType, userType) &&
                    x2.branchId === x.id,
                )
                .sort((a, b) => Number(b.isMain) - Number(a.isMain))
                .map((x2) => {
                  return (
                    <UserAvatar
                      key={x2.userName}
                      name={x2.userName}
                      email={x2.email}
                      label={getUserTypeLabel(
                        x2.userType,
                        x2.customUserType,
                        t,
                      )}
                      showMainBadge={x2.isMain}
                      showTeams={true}
                      size="sm"
                      buttons={
                        <IconUtilButtons
                          isMain={x2.isMain}
                          onChangeCustomTypeClick={
                            onChangeCustomTypeClick
                              ? () =>
                                  onChangeCustomTypeClick(
                                    x2.id,
                                    x2.customUserType ?? '',
                                  )
                              : undefined
                          }
                          customerUserId={x2.id}
                        />
                      }
                    />
                  );
                })}
              <AddUser
                onClick={() => onAddClick(x.id)}
                title={t('customerUser.addUser')}
                sub={t('general.clickToAdd')}
                size="sm"
              />
            </Flex>
          </TeamMatrixCell>
        );
      })}
    </>
  );
}
